/*
    author：peter (185832959@qq.com)
    date：2018-07-04
*/

let base = {
    version: '1.0.0',
    env: 'uat',
    api: {
        domain: 'lingzhuyun.com',
        host: '//uat.ecoapi.lingzhuyun.com',
        openapi: '//uatopenapi.lingzhuyun.com/openapi/external/redirect',
        // host: 'http://192.168.1.228:7777',
        LZY: '/admin',
        LZS: '/lzsite'
    }
}


export default base



// WEBPACK FOOTER //
// ./src/env/uat.js